export default {"src":"/_next/static/media/bz.08c84433.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};